module.exports = __webpack_public_path__ + "static/media/mega-logo.1bef60fd.png";